import React from "react";

export default function Result({ result }) {
  let meaning = result.meanings;

  const MeaningLoop = meaning.map(function (meaning, i) {
    if (i < 2) {
      return (
        <div className="meaning" key={i}>
          <p className="part-of-speech">{meaning.partOfSpeech}</p>
          <p className="definition">{meaning.definition}</p>
          <p className="example">
            {meaning.example ? `"${meaning.example}"` : null}
          </p>
          <ul className="synonyms">
            {meaning.synonyms &&
              meaning.synonyms.map((synonym, j) =>
                j < 6 ? <li key={j}>{synonym}</li> : null
              )}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  });

  return (
    <section>
      <div className="result">
        <h2>{result.word}</h2>
        <p className="phonetic">{result.phonetic}</p>
      </div>
      {MeaningLoop}
    </section>
  );
}
